module.exports = __webpack_public_path__ + "img/shoulder-ecto-mesomorph-female.2ca9ebfc.svg";